/**
 * Kbd — keyboard hint glyph.
 * Mono 10.5 px in a 1 px line border. Used in SearchInput, Savebar, command palette hints.
 * Source: .agents/design/project/artboard-radical.jsx:153-156
 */

interface KbdProps {
  children: React.ReactNode;
  className?: string;
}

export function Kbd({ children, className = '' }: KbdProps) {
  return (
    <kbd
      className={
        'inline-flex items-center border border-line px-[5px] py-px font-mono text-[10.5px] leading-[1.4] text-ink-3 ' +
        className
      }
    >
      {children}
    </kbd>
  );
}
